import { API_CUT_OFF_DEALER } from "../ApiConstants";
import axios from "../client/rest";

class CustomerApi {
  static sharedInstance = new CustomerApi();

  constructor() {
    if (CustomerApi.sharedInstance !== null) {
      return CustomerApi.sharedInstance;
    }
  }

  async cutOffDealer(serialNumber: Number) {
    try {
      const res = await axios.get(API_CUT_OFF_DEALER + serialNumber);
      if (res.status === 200) {
        return res;
      } else {
        throw "Something went wrong";
      }
    } catch (err) {
      throw err;
    }
  }
}

export default CustomerApi.sharedInstance;
